import React from 'react';
import { Link } from 'gatsby';

const NavLink = ({ to, children }) => {
  return (
    <Link to={to} className="p-3 text-lg">
      {children}
    </Link>
  );
};

export default NavLink;
